import { I18n } from '@calendly/i18n'
import { IconButton } from '@calendly/ui/components/icon-button'
import { CloseMiniIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
import { colorTextSecondary } from '@calendly/ui/theme'
import { kebabCase } from 'lodash-es'
import { useSelector, useDispatch } from 'react-redux'

import {
  openUnassignPopup,
  userGroupMembershipsSelector
} from 'features/managed_event_types'

import { ItemDetails, ItemWrapper, ListWrapper, RemoveButtonWrapper, SubsectionWrapper, TextContainer } from '../styles'


export const GroupsTable = () => {
  const dispatch = useDispatch()
  const userGroupMemberships = useSelector(userGroupMembershipsSelector)

  const onUnassignClick = (membershipId) => () => {
    dispatch(openUnassignPopup({ membershipId, owner: 'UserGroup' }))
  }

  return (
    <SubsectionWrapper data-testid="assigned-groups-table">
      <ListWrapper>
        {userGroupMemberships.map(({ id, owner: group }) => (
          <ItemWrapper
            key={`${kebabCase(group.name)}-display`}
            id={`${kebabCase(group.name)}-display`}
            data-testid={`${kebabCase(group.name)}-display`}
          >
            <ItemDetails>
              <TextContainer>
                <BodyText>{group.name}</BodyText>
                <BodyText size="medium" color="muted">
                  {I18n.t('publisher.managed_event_types.event_type.section.group.item_subheader', {
                    count: group.active_group_memberships_count
                  })}
                </BodyText>
              </TextContainer>
            </ItemDetails>
            <RemoveButtonWrapper>
              <IconButton
                size="small"
                title={I18n.t('publisher.action.remove')}
                onClick={onUnassignClick(id)}
              >
                <CloseMiniIcon color={colorTextSecondary} />
              </IconButton>
            </RemoveButtonWrapper>
          </ItemWrapper>
        ))}
      </ListWrapper>
    </SubsectionWrapper>
  )
}
